import React from 'react';
import { ToolComponentProps } from './types';
import { Clock } from 'lucide-react';

export const GetTimeTool: React.FC<ToolComponentProps> = ({ 
  toolName, 
  input, 
  output, 
  isError,
  isExpanded,
  onToggle
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4 text-primary" />
        <span className="font-semibold">Get Time</span>
      </div>

      {output && !isError && (
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 text-center">
          <div className="font-semibold text-primary">
            {output}
          </div>
        </div>
      )}

      {output && isError && (
        <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-3">
          <div className="text-destructive">
            Error: {output}
          </div>
        </div>
      )}
    </div>
  );
};